import React, { useState, useEffect } from 'react';
import { Paper, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Select, MenuItem, Typography } from '@mui/material';
import axiosInstance from '../utills/axiosInstance';

const RequestedLeaves = () => {
    const [requests, setRequests] = useState([]);
    const [statusFilter, setStatusFilter] = useState('All');

    useEffect(() => {
        fetchRequests();
    }, [statusFilter]);

    const fetchRequests = async () => {
        try {
            const res = await axiosInstance.get(`/api/leave/requests?status=${statusFilter === 'All' ? '' : statusFilter}`);
            setRequests(res.data);
        } catch (err) {
            console.error(err);
        }
    };

    const formatDateRange = (fromDate, toDate) => {
        const from = new Date(fromDate).toLocaleDateString();
        const to = new Date(toDate).toLocaleDateString();
        return from === to ? from : `${from} - ${to}`;
    };

    return (
        <Paper sx={{ p: 2, m: 1 }}>
            <Typography variant="h5" textAlign="center">
                Leave Requests
            </Typography>
            <Select value={statusFilter} onChange={(e) => setStatusFilter(e.target.value)} sx={{ mb: 2 }}>
                <MenuItem value="All">All</MenuItem>
                <MenuItem value="Pending">Pending</MenuItem>
                <MenuItem value="Approved">Approved</MenuItem>
                <MenuItem value="Rejected">Rejected</MenuItem>
            </Select>
            <TableContainer>
                <Table>
                    <TableHead>
                        <TableRow>
                            <TableCell>Type</TableCell>
                            <TableCell>From-To</TableCell>
                            <TableCell>Duration</TableCell>
                            <TableCell>Status</TableCell>
                            <TableCell>Reason</TableCell>
                        </TableRow>
                    </TableHead>
                    <TableBody>
                        {requests.map((req) => (
                            <TableRow key={req._id}>
                                <TableCell>{req.leaveType.name}</TableCell>
                                <TableCell>{formatDateRange(req.fromDate, req.toDate)}</TableCell>
                                <TableCell>{req.duration}</TableCell>
                                <TableCell>{req.status}</TableCell>
                                <TableCell>{req.reason}</TableCell>
                            </TableRow>
                        ))}
                    </TableBody>
                </Table>
            </TableContainer>
        </Paper>
    );
};

export default RequestedLeaves;
